import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import styles from './card-category-small.scss?inline';

export default class SotbitCardCategorySmall extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        showImg: { type: Boolean, attribute: 'show-img' },
        href: { type: String },
        alt: { type: String },
        imgUrl: { type: String, attribute: 'img-url' },
    };

    render() {
        return html`<a href="${this.href || nothing}">
            ${this.showImg
                ? html`<span class="img-wrapper">
                      <img loading="lazy" src="${this.imgUrl || nothing}" alt="${this.alt || nothing}" />
                  </span>`
                : ''}
            <span>
                <slot></slot>
            </span>
        </a>`;
    }
}
